export class TransferDTO {

  origem: string;
  destino: string;
  valor: number;
  cambio: number;
  data: string;
  pedido: number;
}
